import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { PlayerProfileService } from "../../../services/playerProfile.Service";

const useStyles = makeStyles((theme) => ({
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  height100: {
    height: "100%",
  },
  label: {
    color: "#8B8B8B",
    wordBreak: "break-all",
  },
  paperStyle: {
    padding: theme.spacing(2),
    marginTop: "15px",
  },
}));

export default function HSEventsAndRankingView(props) {
  const {
    eventId,
    playerID,
    styles,
    highSchoolEventsData,
    rankingsData,
    viewProfile,
    setAlert,
    setAlertMessage,
    user,
  } = props;

  const classes = useStyles();
  //const classes2 = useStyles2();
  const [highSchoolEvents, setHighSchoolEvents] = useState([]);
  const [rankings, setRankings] = useState([]);
  const [rankingYear, setRankingYear] = useState("");
  useEffect(() => {
    PlayerProfileService.getHighSchoolEventsData().then(({ data }) => {
      const highSchoolEventsLocalData = data.map((elem) => ({
        highSchoolEventId: elem.childID,
        highSchoolEventName: elem.childName,
        highSchoolEventCheckBox: false,
        highSchoolEventYear: "",
        mode: "",
      }));

      const updatedData = highSchoolEventsLocalData.map((event) => {
        const match = highSchoolEventsData.find(
          (item) => item.hsEventId === event.highSchoolEventId
        );

        return match
          ? {
              ...event,
              highSchoolEventCheckBox: true,
              highSchoolEventYear: match.eventYear || "",
            }
          : event;
      });

      setHighSchoolEvents(updatedData);
    });
  }, [highSchoolEventsData]);

  useEffect(() => {
    // PlayerProfileService.getHighSchoolEventsData().then(
    //   (highSchoolEventsResponse) => {
    //     let highSchoolEventsLocalData = [];
    //     highSchoolEventsResponse.data.forEach((elem) => {
    //       highSchoolEventsLocalData.push({
    //         highSchoolEventId: elem.childID,
    //         highSchoolEventName: elem.childName,
    //         highSchoolEventCheckBox: false,
    //         highSchoolEventYear: "",
    //         mode: "",
    //       });
    //     });

    //     let apiData = [...highSchoolEventsData];
    //     if (apiData.length) {
    //       apiData.forEach((item) => {
    //         highSchoolEventsLocalData.forEach((elem) => {
    //           console.log('gap',{elem})
    //           if (item.hsEventId === elem.highSchoolEventId) {
    //             elem.highSchoolEventCheckBox = true;
    //             elem.highSchoolEventYear = item.eventYear ? item.eventYear : "";
    //           }
    //         });
    //       });
    //       setHighSchoolEvents(highSchoolEventsLocalData);
    //     }
    //     setHighSchoolEvents(highSchoolEventsLocalData);
    //   }
    // );
    PlayerProfileService.getRankingsData().then((rankingsResponse) => {
      let rankingsLocalData = [];
      rankingsResponse.data.forEach((item) => {
        rankingsLocalData.push({
          rankingId: item.childID,
          rankingName: item.childName,
          rankingCheckBox: false,
          rankingNumber: "",
          mode: "",
        });
      });
      let apiData = [...rankingsData];
      let rankYear = 0;
      if (apiData.length) {
        apiData.forEach((item) => {
          rankYear = item.rankYear;
          rankingsLocalData.forEach((elem) => {
            if (item.rankItemId === elem.rankingId) {
              elem.rankingCheckBox = true;
              elem.rankingNumber = item.rankNumber ? item.rankNumber : "";
            }
          });
        });
        setRankingYear(rankYear);
        setRankings(rankingsLocalData);
      }
      setRankings(rankingsLocalData);
    });
  }, [rankingsData]);

  const handleInputChange = (e, key, id) => {
    let finalValue = e.target.value;
    let newData = [...highSchoolEvents];
    if (key.includes("highSchoolEventYear")) {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key.includes("highSchoolEventCheckBox")) {
      finalValue = e.target.checked;
      if (!finalValue) {
        newData[id - 1].highSchoolEventYear = "";
        newData[id - 1].mode = "delete";
        setHighSchoolEvents(newData);
      } else {
        newData[id - 1].mode = "";
      }
    }
    newData[id - 1][key] = finalValue;
    setHighSchoolEvents(newData);
  };

  const handleRankingInputChange = (e, key, id) => {
    let finalValue = e.target.value;
    let newData = [...rankings];
    if (key.includes("rankingNumber") || key === "rankingYear") {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key.includes("rankingCheckBox")) {
      finalValue = e.target.checked;
      if (!finalValue) {
        newData[id - 1].rankingNumber = "";
        newData[id - 1].mode = "delete";
        setRankings(newData);
      } else {
        newData[id - 1].mode = "";
      }
    }
    if (key === "rankingYear") {
      setRankingYear(finalValue);
    } else {
      newData[id - 1][key] = finalValue;
      setRankings(newData);
    }
  };

  const submitRecord = () => {
    let formObj = [];
    highSchoolEvents.forEach((elem) => {
      if (elem.highSchoolEventCheckBox || elem.mode === "delete") {
        formObj.push({
          id: 0,
          userBy: user.loginID,
          mode: elem.mode,
          playerID: playerID,
          EventId: `${eventId}`,
          hseventId: parseInt(elem.highSchoolEventId),
          eventName: elem.highSchoolEventName,
          eventYear: elem.highSchoolEventYear
            ? parseInt(elem.highSchoolEventYear)
            : 0,
        });
      }
    });
    PlayerProfileService.insertUpdateHighSchoolEvents(formObj).then(
      (result) => {
        formObj = [];
        rankings.forEach((elem) => {
          if (elem.rankingCheckBox || elem.mode === "delete") {
            formObj.push({
              id: 0,
              userBy: user.loginID,
              mode: elem.mode,
              playerID: playerID,
              EventId: `${eventId}`,
              rankItemId: parseInt(elem.rankingId),
              rankItemName: elem.rankingName,
              rankYear: rankingYear ? parseInt(rankingYear) : 0,
              rankNumber: elem.rankingNumber ? parseInt(elem.rankingNumber) : 0,
            });
          }
        });
        PlayerProfileService.insertUpdateRankings(formObj).then((response) => {
          setAlert(true);
          setAlertMessage("Data updated successfully");
        });
      }
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Paper square className={classes.height100}>
            <Box p={1.5}>
              <Typography
                variant="subtitle1"
                mb={1.5}
                fontWeight="medium"
                color="secondary"
              >
                High School Events
              </Typography>
              <Grid container>
                <Grid item xs={3}>
                  <Typography component="p" variant="caption">
                    Event Name
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography component="p" variant="caption">
                    Year
                  </Typography>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={3}>
                  {highSchoolEvents
                    ? highSchoolEvents.map((elem, i) => {
                        return (
                          <Typography
                            key={`typ_${i}`}
                            component="p"
                            variant="subtitle2"
                            noWrap
                          >
                            {elem.highSchoolEventName}
                          </Typography>
                        );
                      })
                    : ""}
                </Grid>
                <Grid item xs={3}>
                  {highSchoolEvents
                    ? highSchoolEvents.map((elem, i) => {
                        return (
                          <Typography
                            key={`typ_${i}`}
                            component="p"
                            variant="subtitle2"
                            noWrap
                          >
                            {elem.highSchoolEventYear
                              ? elem.highSchoolEventYear
                              : "---"}
                          </Typography>
                        );
                      })
                    : ""}
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Paper square className={classes.height100}>
            <Box p={1.5}>
              <Typography
                variant="subtitle1"
                mb={1.5}
                fontWeight="medium"
                color="secondary"
              >
                Rankings
              </Typography>
              <Grid container>
                <Grid item xs={4}>
                  <Box display="flex" flexDirection="column">
                    <Typography component="p" variant="caption">
                      Year
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box display="flex" flexDirection="column">
                    <Typography component="p" variant="caption">
                      {rankingYear ? rankingYear : "---"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={4}>
                  <Box display="flex" flexDirection="column">
                    <Typography component="p" variant="caption">
                      Event Name
                    </Typography>

                    {rankings
                      ? rankings.map((elem, i) => {
                          return (
                            <Typography component="p" variant="subtitle2">
                              {elem.rankingName}
                            </Typography> //  {gridData.address1 ? gridData.address1 : ""}
                          );
                        })
                      : ""}
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box display="flex" flexDirection="column">
                    <Typography component="p" variant="caption">
                      Ranking
                    </Typography>
                    {rankings
                      ? rankings.map((elem, i) => {
                          return (
                            <Typography component="p" variant="subtitle2">
                              {elem.rankingNumber ? elem.rankingNumber : "---"}
                            </Typography>
                          );
                        })
                      : ""}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
